module.exports = __webpack_public_path__ + "static/media/29COICT12.67e23ff1.jpg";